import { NonIdealState } from "@blueprintjs/core";
import { IDataTableColumn, useGridState, useSearchApi } from "nsitools-react";
import * as React from "react";

import { JudgeApi } from "../../../api";
import { useApiService, useTl } from "../../../hooks";
import { ETLCodes } from "../../../locales";
import { DrupalDataTable } from "../../common";
import { DrupalFieldSet } from "../../common/DurpalFieldSet";

export interface IDrupalJudgelistProps {
  breedId: number;
}

export const DrupalJudgelist: React.FunctionComponent<IDrupalJudgelistProps> = ({ breedId }) => {
  const api = useApiService(JudgeApi);
  const { t } = useTl();
  const tableState = useGridState<any>({
    serverMode: true,
    enablePagination: false,
    enableFilter: false,
  });
  const { totalCount } = tableState;
  const searchFunction = React.useCallback(() => {
    if (breedId) {
      return api.searchJudgeByBreed(breedId);
    }
  }, [api, breedId]);

  const { search, loading } = useSearchApi({
    searchFunction,
    tableState,
    initialSearch: true,
    trimSearchObjectStringValues: true,
  });

  React.useEffect(() => {
    search();
  }, [breedId, search]);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.CompleteName),
        fieldName: "name",
        computed: true,
        disableSorting: true,
      },
    ],
    [t]
  );

  return (
    <DrupalFieldSet title={`${t(ETLCodes.Judges)} (${totalCount})`}>
      {breedId ? (
        <DrupalDataTable tableState={tableState} loading={loading} columns={columns} />
      ) : (
        <NonIdealState icon="series-search" title={t(ETLCodes.PLeaseSelectBreed)} />
      )}
    </DrupalFieldSet>
  );
};
